import React, { memo } from 'react';
import { withNativeProps } from '../../utils/native-props';
export var FallbackIcon = /*#__PURE__*/memo(function (props) {
  return withNativeProps(props, /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 32C6 17.6406 17.6406 6 32 6C46.3594 6 58 17.6406 58 32C58 46.3594 46.3594 58 32 58C17.6406 58 6 46.3594 6 32ZM34 36V20H30V36H34ZM30 40V44H34V40H30Z"
  })));
});